import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';

const DashboardProtectedRoute = ({ children }) => {
  const { usuario, authLoading } = useContext(AuthContext);
  const token = localStorage.getItem('token');

  if (authLoading) {
    return (
      <section className="container page-shell">
        <div className="surface-card">
          <p className="mb-0">Validando permisos del dashboard...</p>
        </div>
      </section>
    );
  }

  if (!token || !usuario) {
    return <Navigate to="/login" replace />;
  }

  if (!usuario.dashboard_autorizado) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default DashboardProtectedRoute;
